import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';
import { TraineeIcon } from '@modernloop/shared/icons';
import { Chip } from '@mui/material';

import {
  CurrentTrainingSessionStatus,
  ModuleMemberPendingChip_ModuleMemberFragment,
} from 'src/generated/mloop-graphql';

type Fragments = {
  moduleMember: ModuleMemberPendingChip_ModuleMemberFragment;
};

const ModuleMemberPendingChip: FCWithFragments<Fragments> = ({ moduleMember }) => {
  const { t } = useTranslation('hiring-dashboard-interviewers');

  if (moduleMember.stats?.currentTrainingSessionStatus === CurrentTrainingSessionStatus.NeedsApproval) {
    return <Chip icon={<TraineeIcon />} label={t('interviewers.moduleMember.pending')} color="warning" />;
  }
  return null;
};

ModuleMemberPendingChip.fragments = {
  moduleMember: gql`
    fragment ModuleMemberPendingChip_moduleMember on InterviewModuleMember {
      stats {
        currentTrainingSessionStatus
      }
      id
    }
  `,
};

export default ModuleMemberPendingChip;
